import * as React from 'react';

export type ICssBaseLineTheme = 'light' | 'dark';

export interface ICssBaseline {
  theme: ICssBaseLineTheme;
}

export const CssBaselineContext = React.createContext<ICssBaseline>({
  theme: 'light',
});

export const useCssBaselineContext = (): ICssBaseline => {
  const context = React.useContext(CssBaselineContext);
  if (!context) {
    throw new Error(
      'useCssBaselineContext must be used within the CssBaselineContext.Provider',
    );
  }
  return context;
};
